import ga from '../../../../services/ga';
import {
	EventLabel,
	EventKeys,
	EventCategory,
	EventAction,
	EventValues,
	ErrorArgs,
} from '../../../../services/ga-enums-interfaces';
import { EnrollmentContextService } from '../../../hoc/context/enrollment/enrollment-context';
import {
	gaChangeAdditions,
	gaSuccessEventAdditions,
} from './enrollment-ga-events-additions';
import { DeepMap, FieldError } from 'react-hook-form';
import { IFormInput } from './enrollment.models';

export const sendGaChangeEvent = (e: Event): void => {
	if (!e.target) {
		return;
	}
	const name = (e.target as HTMLInputElement)?.name;
	if (name) {
		ga.sendSimpleEvent(
			EventCategory.ProfileForm,
			EventAction.FieldChange,
			name
		);
		const event = gaChangeAdditions(e);
		if (event) {
			ga.sendEvent(event);
		}
	}
};

export const sendGaFocusEvent = (label: string) => {
	ga.sendSimpleEvent(EventCategory.ProfileForm, EventAction.FieldFocus, label);
};

export const sendGaErrorEvent = (
	errors: ErrorArgs | DeepMap<IFormInput, FieldError>
) => {
	ga.sendErrors(EventCategory.ProfileForm, errors);
};
export const sendGaOnlineErrorEvent = (
	onlineErrors: ErrorArgs | DeepMap<IFormInput, FieldError>,
	name?: string
) => {
	const values = onlineErrors as { [name: string]: { message: string } };
	if (name) {
		ga.sendEvent({
			[EventKeys.EventCategory]: EventCategory.ProfileForm,
			[EventKeys.EventAction]: EventAction.OnlineError,
			[EventKeys.EventLabel]: `${name} - ${values[name].message}`,
			[EventKeys.ErrorForm]: EventValues.ProfileForm,
			[EventKeys.ErrorField]: `${name}`,
			[EventKeys.ErrorName]: `${values[name].message}`,
		});
		return;
	}
	for (const key in onlineErrors) {
		ga.sendEvent({
			[EventKeys.EventCategory]: EventCategory.ProfileForm,
			[EventKeys.EventAction]: EventAction.OnlineError,
			[EventKeys.EventLabel]: `${key} - ${values[key].message}`,
			[EventKeys.ErrorForm]: EventValues.ProfileForm,
			[EventKeys.ErrorField]: `${key}`,
			[EventKeys.ErrorName]: `${values[key].message}`,
		});
	}
};
export const sendGaSuccessEvent = (
	enrollmentCtxt: EnrollmentContextService,
	buttonLabel: string
) => {
	// TODO: move pageRequestTime to gatsby-route-change event
	ga.sendEvent({ [EventKeys.PageRequestTime]: new Date().getTime() });
	ga.sendEvent({
		[EventKeys.EventCategory]: EventCategory.ProfileForm,
		[EventKeys.EventAction]: buttonLabel,
		[EventKeys.EventLabel]: EventLabel.Success,
		[EventKeys.ProfileForm]: EventLabel.Success,
		...gaSuccessEventAdditions(enrollmentCtxt),
	});
};

export const sendGaIneligibleEvent = () => {
	ga.sendSimpleEvent(EventCategory.Ineligible, 'Result', 'Incomplete');
};
